
<div>
  <div class="title mb-2">Access Levels</div>
  <p>Here you can set the access levels for this special occurrence. All members of the board will have the same access level.</p>
  <dl class="shadow-sm bg-white p-3">
    <dt>Admin</dt>
    <dl>Full control (including linked tasks)</dl>

    <dt>Editor</dt>
    <dl>
      Full control (including linked tasks)
      <strong>except</strong>
      modifying access rights
    </dl>
    <dt>Contributor</dt>
    <dl>Can access all linked tasks, can create items for own board, can <strong>not</strong> modify/ complete the special occurrence</dl>

    <dt>None</dt>
    <dl>Special Occurrence is not visible</dl>
  </dl>
  <table class="table table sm bg-white shadow-sm">
    <thead>
      <tr>
        <th>Board</th>
        <th>Access Level</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="accessLevel in accessLevels" :key="accessLevel.boardId">
        <td class="font-weight-bold">
          {{ accessLevel.boardName }}
          <span v-if="accessLevel.boardId === occurrence.ownerBoardId">
            <strong><span class="badge badge-success">Owner</span></strong>
          </span>
        </td>
        <td>
          <div
            class="badge mr-2"
            :class="{ 'badge-primary': accessLevel.accessLevel === 'None' }"
            @click="setAccess(accessLevel.boardId, 'None')"
          >
            None
          </div>
          <div
            class="badge mr-2"
            :class="{ 'badge-success': accessLevel.accessLevel === 'Admin' }"
            @click="setAccess(accessLevel.boardId, 'Admin')"
          >
            Admin
          </div>
          <div
            class="badge mr-2"
            :class="{ 'badge-success': accessLevel.accessLevel === 'Editor' }"
            @click="setAccess(accessLevel.boardId, 'Editor')"
          >
            Editor
          </div>
          <div
            class="badge mr-2"
            :class="{ 'badge-success': accessLevel.accessLevel === 'Contributor' }"
            @click="setAccess(accessLevel.boardId, 'Contributor')"
          >
            Contributor
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</div>
